import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ContactFormLoaderEffects } from './+state/contact-form-loader-eager.effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([ContactFormLoaderEffects])]
})
export class ContactFormLoaderModule {}
